import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section id="faq" className="bg-cream py-20 sm:py-28" data-id="element-79" data-mp="3uwi2z6sqcl9w">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-80" data-mp="3utvv161xg3r5">
        <div className="mx-auto max-w-3xl text-center" data-id="element-81" data-mp="3qveksdn7md5i">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-82" data-mp="3lva3wmie3ger">FAQ</p>
          <h2 className="mt-4 font-serif text-4xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-83" data-mp="3lxmwruporb6l">
            Everything you need to know <em className="text-gold" data-id="element-84" data-mp="3bxcjyb7kc5ry">before you start</em>
          </h2>
        </div>

        <ul className="mx-auto mt-12 max-w-3xl border-t border-ink/15" data-id="element-85" data-mp="1f4u435u5oiog">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="border-b border-ink/15" data-id="element-86" data-mp="1a6iumw7rwa6r" data-mpi={i}>
                <h3 data-id="element-87" data-mp="1cp6j7btnxcm4">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-start justify-between gap-6 py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-88" data-mp="1con2tzjnuwa7">
                    <span className="font-serif text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-89" data-mp="1vi0o1cxknocm">{f.q}</span>
                    <PlusIcon className={`mt-1 h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden data-id="element-90" data-mp="20f0vnsa2kz5u" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-91" data-mp="2eeip4kyb90lj">
                  {isOpen && <motion.div id={`faq-${i}`} initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-92" data-mp="2j6tlxexr869v">
                      <p className="pb-6 pr-10 leading-relaxed text-body" data-id="element-93" data-mp="2f27y19lhoot4">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}